import {createSelector} from 'reselect';
import {
  GET_CURRENT_USER_SUCCESS,
  GET_USERS_STATS_SUCCESS,
  GET_USERS_SUCCESS,
  SET_BLOCK_INCOMING_CALLS,
  UsersAction
} from './users.action';

export interface UsersState {
  users: any[];
  usersStats: any;
}

export const initialState: UsersState = {
  users: [],
  usersStats: null
};

export function usersReducer(state: UsersState = initialState, action: UsersAction): UsersState {
  switch (action.type) {
    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload
      };
    case GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        users: action.payload
      };
    case GET_USERS_STATS_SUCCESS:
      return {
        ...state,
        usersStats: action.payload
      };
    case SET_BLOCK_INCOMING_CALLS:
       const userIndex = state.users.findIndex(userDetails => userDetails.id === action.payload.id);
       state.users[userIndex].doNotAcceptIncomingCalls = action.payload.blocked;
      return {
        ...state,
        usersStats: action.payload
      };
    default: {
      return state;
    }
  }
}

export const getUsers = (state: UsersState) => state.users;
export const getUsersStats = (state: UsersState) => state.usersStats;

export const getMainUsersSelector = (state): UsersState => state.users;
export const getUsersSelector = createSelector(getMainUsersSelector, getUsers);
export const getUsersStatsSelector = createSelector(getMainUsersSelector, getUsersStats);
